import React from 'react';
import { Info } from 'lucide-react';
import { SURETY_FIELD_HELP, type SuretyFieldHelpKey } from '../../utils/suretyBondRequest';

interface FieldHelpProps {
  /** Key into SURETY_FIELD_HELP, or free text. */
  text: SuretyFieldHelpKey | string;
  /** Tooltip alignment when the field sits at the right edge of the grid. */
  align?: 'left' | 'right';
}

/** Small info icon with a hover / focus tooltip, used beside form labels. */
const FieldHelp: React.FC<FieldHelpProps> = ({ text, align = 'left' }) => {
  const copy = (SURETY_FIELD_HELP as Record<string, string>)[text] ?? text;
  return (
    <span className={`reg-help${align === 'right' ? ' is-right' : ''}`}>
      <button type="button" className="reg-help-btn" aria-label="What is this for?" tabIndex={0}>
        <Info size={11} aria-hidden />
      </button>
      <span role="tooltip" className="reg-help-tip">{copy}</span>
    </span>
  );
};

export default FieldHelp;
